import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { InfoFilledIcon } from '@sharedCR/coreDesignSystem/icons';

import { FeesStepTestIds } from '../../FeesStep.testIds';

import { emphasisStyles, iconStyles, noteStyles, textStyles } from './FeeBaselineNote.styles';

const FeeBaselineNote = () => (
  <Box data-testid={FeesStepTestIds.BASELINE_NOTE} sx={noteStyles}>
    <Box sx={iconStyles}>
      <InfoFilledIcon size={18} />
    </Box>
    <Typography sx={textStyles} variant="regular14">
      <Typography component="span" sx={emphasisStyles} variant="bold14">
        Sending this LE sets your fee baseline.
      </Typography>{' '}
      Later increases to zero-tolerance fees can only change with a documented changed circumstance
      — handled automatically.
    </Typography>
  </Box>
);

export default memo(FeeBaselineNote);
